/*
 * Copyright (c) 2023 Vizient Inc.
 *
 * Service for managing local browser storage data
 */

import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { PassingComponentData } from "../models";

/**
 * Used to write and read from local browser storage
 * and consumed by components
 */
@Injectable({
  providedIn: "root",
})
export class SessionManagementService {
  constructor() {}

  /**
   * sets the domainId
   * @param id - domain id
   */
  setDomainId(id: number) {
    localStorage.setItem("domainId", JSON.stringify(id));
  }

  /**
   * gets the domainId
   */
  getDomainId() {
    return localStorage.getItem("domainId");
  }

  /**
   * sets the datasetId
   * @param id - domain id
   */
  setDatasetId(id: number) {
    localStorage.setItem("datasetId", JSON.stringify(id));
  }

  /**
   * gets the datasetId
   */
  getDatasetId() {
    return localStorage.getItem("datasetId");
  }

  /**
   * removes domainId and datasetId
   */
  removeAll() {
    localStorage.removeItem("domainId");
    localStorage.removeItem("datasetId");
  }

  /**
   * sets the object
   * @param data - interface object to be saved
   */
  setPassingComponentData(data: PassingComponentData) {
    localStorage.setItem("passingComponentData", JSON.stringify(data));
  }

  /**
   * gets the object
   */
  getPassingComponentData(): PassingComponentData {
    let result = localStorage.getItem("passingComponentData");
    return JSON.parse(result) as PassingComponentData;
  }
}
